export const allowedCharactersRegex = /^[a-zA-Z\u00C0-\u017F' -]+$/;
export const phoneNumberRegex =
  /^(?:\+?\d{1,3})?[-.\s]?\(?\d{1,4}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
export const prohibitedCharsRegex = /[A-Za-z!@#$%^&*/={}\[\]|\\:;"'<>,?`]/;
// export const allowedCharactersRegex = /^[a-zA-Z\s'’-]+$/; /^[\d\s\(\)\-\+\'\u00C0-\u017F]+$/
